import React, { createContext, ReactNode, useContext } from 'react'


import { useQuery } from 'react-query'
import { Permission } from '../api/models'
import { skuit } from '../services/skuit'

interface ISupplyChainPermissionsContext {
  permissions: Permission[]
}

export const SupplyChainPermissionsContext =
  createContext<ISupplyChainPermissionsContext>(
    {} as ISupplyChainPermissionsContext
  )

export function SupplyChainPermissionsProvider({
  children,
}: {
  children: ReactNode
}): JSX.Element {
  const { data: permissions } = useQuery({
    queryKey: ['supply-chain-permissions-mine'],
    queryFn: () => skuit.sc.permissions.list('mine'),
  })

  return (
    <SupplyChainPermissionsContext.Provider
      value={{ permissions: permissions || [] }}
    >
      {children}
    </SupplyChainPermissionsContext.Provider>
  )
}

export function useSupplyChainPermissionsContext() {
  const context = useContext(SupplyChainPermissionsContext)
  if (context === undefined) {
    throw new Error(
      'useSupplyChainPermissionsContext must be used within a SupplyChainPermissionsProvider'
    )
  }
  return context
}

